// The library skin first, so the overrides in main.css win the ties; through JS, because the CSS
// pipeline leaves bare module imports inside css files unresolved.
import 'flatpickr/dist/flatpickr.css'
import './css/main.css'

import { createPinia } from 'pinia'
import { createApp } from 'vue'

import App from './App.vue'
import { readConfig } from './config'

const mount = document.getElementById('net-metering')

// The block is placed by an editor, so the mount point is not guaranteed to be on the page. A
// missing mount point leaves the rest of the page working.
if (mount) {
  createApp(App, readConfig(mount)).use(createPinia()).mount(mount)
}
